/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { Component, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  loadPreferredSuppliersList,
  toggleRemoveFromPslModal,
} from "../../actions/preferredSuppliersListActions";
import ActionBar from "../shared/general/ActionBar";
import FullScreenLoading from "../shared/loaders/FullScreenLoading";
import EmployerPslList from "./EmployerPslList";
import RecruiterPslList from "./RecruiterPslList";
import RemoveFromPslModal from "./RemoveFromPslModal";
import FlashMessage from "../shared/general/FlashMessage";
import { Wrapper } from "./styles/psl-styles";

interface IPreferredSuppliersListProps {
  loadPreferredSuppliersList: () => void;
  loading: boolean;
  removeModalActive: boolean;
  isEmployer: boolean;
  toggleRemoveFromPslModal: () => void;
  showFlashMessage: boolean;
}

interface ISupplierProps {
  id?: number;
  name?: string;
  createdAt?: string;
  recruiterId?: number;
  activeEngagementCount?: number;
  recruiter?: {
    id?: number;
    name?: string;
  };
}
interface IPreferredSuppliersListState {
  removeFromPslData: {
    preferredSupplier?: ISupplierProps;
  };
}

export class PreferredSuppliersList extends Component<
  IPreferredSuppliersListProps,
  IPreferredSuppliersListState
> {
  static propTypes = {
    loadPreferredSuppliersList: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    removeModalActive: PropTypes.bool.isRequired,
    isEmployer: PropTypes.bool.isRequired,
    toggleRemoveFromPslModal: PropTypes.func.isRequired,
    showFlashMessage: PropTypes.bool.isRequired,
  };

  state = {
    removeFromPslData: {},
  };

  componentDidMount(): void {
    const { loadPreferredSuppliersList } = this.props;
    loadPreferredSuppliersList();
  }

  setRemoveFromPslData = (
    e: { preventDefault: () => void },
    data: {
      preferredSupplier: ISupplierProps;
    }
  ): void => {
    e.preventDefault();
    const { toggleRemoveFromPslModal } = this.props;
    toggleRemoveFromPslModal();
    this.setState({ removeFromPslData: data });
  };

  render(): ReactNode {
    const { loading, isEmployer, removeModalActive, showFlashMessage } =
      this.props;
    const { removeFromPslData } = this.state;

    return (
      <>
        <FlashMessage
          message="Successfully removed from your PSL"
          success
          showFlashMessage={showFlashMessage}
        />
        <ActionBar
          title="Preferred Suppliers List"
          mobileTitle="Preferred Suppliers List"
          loading={loading}
        />
        {loading ? (
          <FullScreenLoading />
        ) : (
          <Wrapper>
            {removeModalActive && (
              <RemoveFromPslModal removeFromPslData={removeFromPslData} />
            )}
            {isEmployer ? (
              <EmployerPslList
                setRemoveFromPslData={this.setRemoveFromPslData}
              />
            ) : (
              <RecruiterPslList />
            )}
          </Wrapper>
        )}
      </>
    );
  }
}

interface IReduxState {
  preferredSuppliersList: {
    loading: boolean;
    isEmployer: boolean;
    removeModalActive: boolean;
    showFlashMessage: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  loading: state.preferredSuppliersList.loading,
  isEmployer: state.preferredSuppliersList.isEmployer,
  removeModalActive: state.preferredSuppliersList.removeModalActive,
  showFlashMessage: state.preferredSuppliersList.showFlashMessage,
});

export default connect(mapStateToProps, {
  loadPreferredSuppliersList,
  toggleRemoveFromPslModal,
})(PreferredSuppliersList);
